import { PercentTypes } from '@/utils/enums';

export const PERSENT_TYPES = [
  { label: 'Сдельный % за залоги', value: PercentTypes.PIECE_RATE_FOR_COLLATERAL },
  { label: 'Сдельный % за перезалоги', value: PercentTypes.PIECE_RATE_FOR_REMORTGAGES },
  { label: 'Сдельный % за пролонгации', value: PercentTypes.PIECE_RATE_FOR_PROLONGATIONS },
  { label: 'Доп. сдельный % за пролонгации', value: PercentTypes.ADD_PIECE_RATE_FOR_PROLONGATIONS },
  { label: 'Сдельный % за выкупы', value: PercentTypes.PIECE_RATE_FOR_BUYOUTS },
];
